"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfileApiEndpoint = void 0;
const getProfileApiEndpoint = (environment, region) => {
    const domainName = region === 'eu-west-1' ? 'profiles.euw1.segment' : 'profiles.segment';
    const topLevelName = environment === 'production' ? 'com' : 'build';
    return `https://${domainName}.${topLevelName}`;
};
exports.getProfileApiEndpoint = getProfileApiEndpoint;
//# sourceMappingURL=getProfileApiEndpoint.js.map